module.exports = __webpack_public_path__ + "static/media/main.59cacf3e.png";